import i18n, { NAMESPACE } from '@app/i18n';
import {
  CSV_CATALOG,
  localizedHeaders,
  UTF8_BOM,
} from '@app/utils/csv-headers';

// Dynamic import keeps papaparse out of the main entrypoint bundle
const loadPapa = () => import('papaparse').then((m) => m.default);

// Lazily loaded papaparse; module-private — callers should use usersJsonToCSV (async).
const jsonToCSV = async (json, delimiter, columns) => {
  const Papa = await loadPapa();
  return Papa.unparse(json, { delimiter, columns });
};

export const usersJsonToCSV = async (users, isTitleEnabled) => {
  await i18n.loadNamespaces(NAMESPACE.TEAM_MANAGEMENT);
  const t = (key) =>
    i18n.t(`bulkUpload.export.${key}`, { ns: NAMESPACE.TEAM_MANAGEMENT });

  const keys = CSV_CATALOG.BULK_USERS_EXPORT.filter(
    (key) => isTitleEnabled || key !== 'title',
  );
  const labels = localizedHeaders(keys);
  const labelFor = Object.fromEntries(keys.map((key, i) => [key, labels[i]]));

  const usersFormatted = users.map((user) => ({
    [labelFor.uniqueId]: user.oktaUserId,
    [labelFor.firstName]: user?.profile?.firstName,
    [labelFor.lastName]: user?.profile?.lastName,
    ...(isTitleEnabled ? { [labelFor.title]: user?.profile?.title } : {}),
    [labelFor.lastLogin]: user?.lastLoginTime,
    [labelFor.phoneNumber]: user?.profile?.phoneNumber,
    [labelFor.officeLine]: user?.profile?.contactNumber,
    [labelFor.email]: user?.email,
    [labelFor.roles]: user?.roles?.join(', '),
    [labelFor.groupMembers]: user?.groups?.join('; '),
    [labelFor.groupLeads]: user?.groupLeads?.join('; '),
    [labelFor.active]: user?.active ? t('yes') : t('no'),
  }));

  const csv = await jsonToCSV(usersFormatted, ',', labels);
  return `${UTF8_BOM}${csv}`;
};
